import type React from "react";
import { useState } from "react";

import { IconButton } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import {
    StyledAddButton,
    StyledChipItem,
    StyledTextField,
} from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/agent-knowledge-base/components/ChipGroup/styles";

type Props = {
    value: string[];
    onChange: (value: string[]) => void;
    onRemove?: (item: string) => void;
    onAdd?: (item: string) => void;
    onNewValueChange?: (value: string | undefined) => void;
};

export const ChipGroup: React.FC<Props> = ({ value, onChange, onNewValueChange, onAdd, onRemove }) => {
    const [isInputVisible, setIsInputVisible] = useState(false);
    const [inputValue, setInputValue] = useState<string | undefined>(undefined);

    const handleRemove = (item: string) => {
        const updatedValue = value.filter((productOffering) => productOffering !== item);
        onChange(updatedValue);
        onRemove?.(item);
    };

    const handelAdd = () => {
        const trimmedValue = inputValue?.trim();
        const isDuplicate = value?.some((item) => item === trimmedValue);

        if (trimmedValue && !isDuplicate) {
            const updatedValue = [...value, trimmedValue];

            onChange(updatedValue);
            onAdd?.(trimmedValue);

            setInputValue(undefined);
            setIsInputVisible(false);
            onNewValueChange?.(undefined);
        }
    };

    const handleInputChange = (value: string) => {
        setInputValue(value);
        onNewValueChange?.(value);
    };

    const handleClear = () => {
        setInputValue("");
        setIsInputVisible(false);
    };

    return (
        <Flex
            flexWrap="wrap"
            gap="8px"
        >
            {value?.map((item) => (
                <StyledChipItem
                    onCloseItem={() => handleRemove(item)}
                    text={item}
                    enabledTooltip={true}
                    displayTooltipForTextLongerThan={63}
                    tooltipMaxWidth={230}
                    key={item}
                />
            ))}
            {isInputVisible ? (
                <Flex
                    alignItems="center"
                    gap="2px"
                >
                    <StyledTextField
                        onChange={handleInputChange}
                        autoFocus={true}
                        customIndicator={
                            <StyledAddButton
                                type="flat"
                                onClick={handelAdd}
                            >
                                {translate("common.add")}
                            </StyledAddButton>
                        }
                    />
                    <IconButton
                        iconName="close"
                        iconSize="10px"
                        type="flat"
                        onClick={handleClear}
                    />
                </Flex>
            ) : (
                <IconButton
                    type="flat"
                    iconName="plus"
                    iconSize="10px"
                    onClick={() => setIsInputVisible(true)}
                >
                    {translate("si.agent_knowledge_base.modal.productOffering.button.add")}
                </IconButton>
            )}
        </Flex>
    );
};
